import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import RowActions from 'components/RowActions';

import { rowActions as TEXT } from 'locales/en/transaction';
import { SendReceipt } from 'pages/Transactions/Detail/buttons';

const RefundActions = ({ isOpen, onClickOpen, onClose, item, position }) => {
  return (
    <RowActions
      onClickOpen={onClickOpen}
      isOpen={isOpen}
      onClose={onClose}
      position={position}
    >
      <Link
        to={{
          pathname: `/transactions/${item.transaction_id}`,
          scrollToRefunds: true,
        }}
        className="block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer"
      >
        {TEXT.viewDetails}
      </Link>
      <SendReceipt
        transaction={item}
        className="block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer"
      />
    </RowActions>
  );
};

RefundActions.propTypes = {
  onClickOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'bottom']),
  item: PropTypes.shape({}),
};
RefundActions.defaultProps = {
  position: 'bottom',
  item: {},
};

export default memo(RefundActions);
